'use strict';
import React, { PureComponent } from 'react';
import Header from './Header'
import Formulario from './Formulario'
import Tabla from './Tabla'

class IngresoCobranzas extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            currentAccuntId: this.props.data.idEntidad
        }
    }

    componentDidMount() {
        /*el id que cambia es el idEntidad de panel seleccion*/
        this.props.getScreenData(this.props.vistaCliente.userFeatures, this.props.data.idEntidad);
    }

    componentWillReceiveProps(nextProps) {
        if (this.state.currentAccuntId != nextProps.data.idEntidad) {
            this.setState({ currentAccuntId: nextProps.data.idEntidad });
            this.props.getScreenData(this.props.vistaCliente.userFeatures, nextProps.data.idEntidad);
        }
    }

    componentWillUnmount() {
        this.props.resetState();
    }

    render() {
        const { ingresoCobranzas, limpiar, aceptar, data, seleccionarMoneda, confirmar, denegar, editar,
            eliminar, expandirRow, sesion, changeImporte, changeReferencia, changeDate } = this.props;
        const { cuenta, isLoading, accion } = ingresoCobranzas;
        const ingresoCobranza = ingresoCobranzas.data;
        const cobranzas = ingresoCobranza.cobranzas;
        const rowSeleccionada = ingresoCobranza.rowSeleccionada;
        const permisosUsuario = data.features.CARGACOBRANZA;
       
        let componente = <div className="loading">Loading &#8230;</div>;
        
        //if (!isLoading) {

        componente = <div>
          
            <Header data={data} />
            {permisosUsuario &&
                permisosUsuario.Alta &&
                <Formulario ingresoCobranza={ingresoCobranza}
                    seleccionarMoneda={seleccionarMoneda}
                    limpiar={limpiar}
                    aceptar={aceptar}
                    changeImporte={changeImporte}
                    changeReferencia={changeReferencia}
                    changeDate={changeDate}
                />
            }
            <Tabla ingresoCobranza={ingresoCobranza}
                cobranzas={cobranzas}
                rowSeleccionada={rowSeleccionada}
                confirmarCobranza={confirmar}
                denegarCobranza={denegar}
                editar={editar}
                eliminarCobranza={eliminar}
                expandirRow={expandirRow}
                permisosUsuario={permisosUsuario}
            />
        </div>;
        //}

        return (
            <div className="">
                <div className="container-fluid">
                    {componente}
                </div>
            </div>
        );
    }
}

export default IngresoCobranzas;